import React from "react";
import { useMediaQuery } from "@mui/material";

const PrivacySection = () => {
    const isMobile = useMediaQuery("(max-width: 767px)");
    return (
        <section
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "stretch",
                backgroundColor: "#FFFFFF",
                padding: isMobile ? "80px 20px" : "120px 80px",
                borderRadius: "10px",
                textAlign: "justify",
                color: "black",
            }}
            className="py-16 bg-secondary-100 text-secondary pb-50"
        >
            <div className="container mx-auto lg:px-4">
                <main className="flex-grow lg:p-8 max-w-full">
                    <h1 className="lg:text-4xl text-3xl leading-normal font-bold text-center lg:mb-8 mb-6">
                        Privacy Policy
                    </h1>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Introduction</h2>
                        <p className="mb-4">
                            Welcome to PT Tennet Depository Indonesia (Tennet, Company, we, our,
                            or us) commitment to safeguarding your personal data. This Privacy
                            Policy applies to your use of https://www.tennet.id and its subdomains
                            (individually referred to as Site and collectively as Sites), our mobile
                            application for iOS and Android (the App), and the other services,
                            features, products, content or applications provided by Tennet,
                            including but not limited to the wallet, vault app, self custody, and
                            additional services offered over time (collectively referred to as the
                            Tennet Service).
                        </p>
                        <p>
                            This Privacy Policy outlines how Tennet collects, processes,
                            transforms, discloses, retains, secures, analyzes, erases, and/or
                            destroys the personal data of users ("Users", "You", "Your") for the
                            purpose of providing the Tennet Service.
                        </p>
                        <p className="mt-4">
                            By using Tennet Service, you acknowledge and agree to the terms
                            outlined in this Privacy Policy. We encourage you to carefully read and
                            understand the following sections, as they detail how Tennet handles your
                            personal information.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Our Commitment to Your Privacy</h2>
                        <p>
                            Your privacy is of utmost importance to us. We understand the trust
                            you place in Tennet when providing us with your personal information,
                            and we are dedicated to ensuring that your data is handled with the
                            highest level of confidentiality and security.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Personal Data Collection</h2>
                        <ol className="list-decimal ml-6 space-y-4 text-base">
                            <li>
                                <strong>Personal Data:</strong> Means any information that can be
                                used to identify a person individually.
                            </li>
                            <li>
                                <strong>Collection of Personal Data:</strong> We gather Personal Data
                                about you through various channels. This includes instances when you
                                directly provide information to us, when our business partners or
                                service providers share your Personal Data with us, or when Personal
                                Data is automatically collected as part of your interaction with our
                                Services.
                            </li>
                            <li>
                                <strong>Information Directly Provided by You:</strong> We receive
                                Personal Data directly from you when you provide us with such Personal
                                Data, including without limitation account information (full name,
                                email address, phone number) and any Personal Data you provide when you
                                communicate with us.
                            </li>
                            <li>
                                <strong>Automatic Data Collection:</strong> When utilizing Tennet
                                Service, certain Personal Data is automatically collected to enhance
                                your experience. This includes IP address, web browser information,
                                operating system information, pages visited and links clicked, usage
                                data (cookies), and any personal data provided during communication with
                                us or our customer service representatives.
                            </li>
                            <li>
                                <strong>Data Not Collected:</strong> In respecting your privacy, there
                                are specific types of information that we deliberately do not collect
                                when you use Tennet Services. This includes browsing history outside of
                                the services, social media profiles, and cookies for targeting and
                                marketing.
                            </li>
                            <li>
                                <strong>Authorization for Providing Others' Personal Data:</strong>
                                When supplying us with the Personal Data of others, you confirm that you
                                have the necessary authority to do so. Any information about third
                                parties that you share with us during your use of the Services is your
                                responsibility.
                            </li>
                            <li>
                                <strong>Third-Party Services:</strong> This Privacy Policy does not
                                cover third-party services and encourages Users to review the privacy
                                policies of any third-party services they access through Tennet.
                            </li>
                        </ol>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Information Regarding Cookies</h2>
                        <ol className="list-decimal ml-6 space-y-4 text-base">
                            <li>
                                <strong>Definition and Purpose:</strong> Cookies are small files,
                                typically composed of letters and numbers, placed on your device.
                                These files enable our servers to recognize your web browser,
                                informing us about the timing and manner of your visits to our Site
                                and Services. The primary purpose is to operate our Services
                                effectively.
                            </li>
                            <li>
                                <strong>No Use for Targeted Advertising:</strong> We do not employ
                                Cookies for targeting you with advertising or promotions related to our
                                products and services. Additionally, we do not augment the information
                                collected from you with data received from third parties.
                            </li>
                            <li>
                                <strong>Absence of Similar Technologies:</strong> Technologies such as
                                pixel tags, web beacons, clear GIFs, and JavaScript are not employed by
                                us to track or identify you.
                            </li>
                            <li>
                                <strong>Types of Cookies:</strong> Cookies can be categorized as either
                                session Cookies (temporary files stored while you are using our Site or
                                Services) or persistent Cookies (files stored on your device for a
                                duration after leaving our Site or Services). The duration of
                                persistence varies from one Cookie to another.
                            </li>
                            <li>
                                <strong>Use of Persistent Cookies:</strong> Persistent Cookies are used
                                to maintain a more accurate record of your visit frequency, return
                                frequency, and variations in your use of the Services over time.
                            </li>
                            <li>
                                <strong>Do Not Track Option:</strong> Some browsers offer a 'Do Not
                                Track' (DNT) option, allowing you to signal your preference not to be
                                tracked across different websites. As our Services collect browsing and
                                persistent identifier data, we currently do not support Do Not Track
                                requests.
                            </li>
                            <li>
                                <strong>Third-Party Cookies:</strong> We do not exercise control over
                                third-party Cookies. While some Cookies may be placed by third parties
                                on your device, we neither collect nor use the information derived from
                                such Cookies.
                            </li>
                        </ol>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Essential Cookies</h2>
                        <p className="mb-4">
                            We employ Essential Cookies to deliver specific features or services
                            that you have explicitly requested. These Cookies play a critical role
                            in ensuring the smooth functioning of essential functions.
                        </p>
                        <ol className="list-decimal ml-6 space-y-3 text-base">
                            <li>
                                <strong>Secure Area Access:</strong> Enabling you to log into secure
                                areas of our Site or Services, ensuring that your interactions with
                                sensitive information remain protected.
                            </li>
                            <li>
                                <strong>Preference Maintenance:</strong> Facilitating the retention of
                                your preferences over time, ensuring a personalized and consistent
                                experience during your visits.
                            </li>
                            <li>
                                <strong>User Recognition:</strong> Recognizing you when you return to
                                our Services, streamlining the user experience by remembering your
                                previous interactions and settings.
                            </li>
                        </ol>
                        <p className="mt-4">
                            Disabling these Essential Cookies may result in the unavailability of
                            certain features and services. It is essential to keep these Cookies
                            enabled to ensure the smooth and secure functioning of the requested
                            features, maintaining the integrity of your preferences and recognizing
                            you across your interactions with our Services.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Cookies That We Don&apos;t Use</h2>
                        <p className="mb-4">
                            We do not utilize the following types of Cookies:
                        </p>
                        <ul className="list-disc ml-8 space-y-2 text-base">
                            <li>Performance/Analytical Cookies</li>
                            <li>Retargeting/Advertising Cookies</li>
                        </ul>
                        <p className="mt-4">
                            The decision to accept or reject Cookies is within your control. You can
                            manage this through your internet browser's settings. Most browsers
                            include an option to disable the Cookie feature, preventing your browser
                            from accepting new Cookies. Depending on your browser's capabilities,
                            you may also have the ability to decide on the acceptance of each new
                            Cookie in various ways.
                        </p>
                        <p className="mt-4">
                            However, be aware that disabling Cookies may require manual adjustment
                            of preferences each time you visit a site, and certain services and
                            functionalities may be impacted. For more information about Cookies,
                            including guidance on how to manage and delete them, please visit:
                        </p>
                        <ul className="list-disc ml-8 mt-3 text-base">
                            <li>
                                <a href="https://ico.org.uk/for-the-public/online/cookies/" target="_blank" rel="noreferrer" className="text-blue-600 underline">
                                    https://ico.org.uk/for-the-public/online/cookies/
                                </a>
                            </li>
                            <li>
                                <a href="http://www.allaboutcookies.org/" target="_blank" rel="noreferrer" className="text-blue-600 underline">
                                    http://www.allaboutcookies.org/
                                </a>
                            </li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Disclaimer</h2>
                        <p>
                            We explicitly state that we do not engage in the buying or selling of
                            user data. In the event of any data transfer, rest assured that it will
                            be carried out in strict adherence to established privacy standards.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">How We Use Your Data</h2>
                        <p>
                            We process your Personal Data for various purposes essential to the
                            Tennet Service. This includes verifying and establishing your account,
                            processing and fulfilling product or service purchases, protecting
                            against fraudulent or harmful actions, communicating updates, offers,
                            and relevant information, providing support and assistance, identifying
                            trends for business improvement, complying with legal or contractual
                            obligations, responding to inquiries, fulfilling requests, resolving
                            disputes, and enforcing our Terms and Conditions.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Lawful Bases for Processing</h2>
                        <p>
                            We process data based on consent, contractual necessity, and
                            legitimate interests exemplified by account information necessary for
                            services, usage data for business interests, and information for fraud
                            protection, legal compliance, and corporate transactions.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Sharing Data</h2>
                        <p>
                            At Tennet, we're committed to safeguarding your information. Here's a
                            straightforward breakdown of how and with whom we share your data:
                        </p>
                        <ol className="list-decimal ml-6 space-y-3 text-base">
                            <li>
                                <strong>Trusted Partnerships:</strong> We share only necessary
                                information with partners like cryptocurrency exchange service
                                providers, hosting services, email providers, and others, adhering to
                                strict requirements.
                            </li>
                            <li>
                                <strong>Legal Compliance:</strong> When required by law or for security
                                reasons, we may share your data with relevant authorities.
                            </li>
                            <li>
                                <strong>Safeguarding Tennet and Users:</strong> In scenarios such as
                                enforcing our policies or preventing fraud, we might share data to
                                protect Tennet and our users.
                            </li>
                            <li>
                                <strong>Communication Essentials:</strong> Anticipate emails and
                                messages from us related to your use of our services.
                            </li>
                            <li>
                                <strong>Business Transitions:</strong> In the event of business changes,
                                data may transfer to entities upholding privacy policies similar to
                                ours. Any future changes will maintain the same commitment to
                                safeguarding your data.
                            </li>
                        </ol>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Security of User Personal Data</h2>
                        <p>
                            Tennet prioritizes the security and storage of User Personal Data,
                            implementing rigorous measures to uphold confidentiality. We seek to
                            protect Personal Data using appropriate technical and organizational
                            measures based on the type of Personal Data and applicable processing
                            activity.
                        </p>
                        <p className="mt-4">
                            Content uploaded or sent by Users through Tennet Service is securely
                            stored and transmitted, adhering to industry standards for electronic
                            information security. Tennet upholds stringent information security
                            standards, including ISO 27001:2013 certification for Information
                            Security Management Systems and ISO 27701:2019 certification for
                            Privacy Information Management Systems.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Privacy by Design and Privacy by Default</h2>
                        <p>
                            Tennet shall deploy suitable technical and organizational measures
                            designed to enforce this Policy, both during the determination of
                            Processing methods and throughout the actual Processing.
                        </p>
                        <p className="mt-4">
                            Specifically, in the development of databases and the formulation of
                            procedures for Personal Data collection, due consideration must be given
                            to the principles of Personal Data Processing and the rights of Data
                            Subjects, and such considerations shall be duly reflected.
                        </p>
                        <p className="mt-4">
                            Tennet shall also institute appropriate technical and organizational
                            measures in alignment with the Tennet Policy on Protection of Personal
                            Data to ensure that, by default, only the Personal Data necessary for
                            each specific Processing purpose is indeed processed.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Data Protection Impact Assessment</h2>
                        <p>
                            In instances where the Processing of Personal Data is anticipated to
                            pose substantial risks to the rights or freedoms of Data Subjects,
                            Tennet shall undertake a comprehensive data protection impact
                            assessment before commencing the Processing.
                        </p>
                        <p className="mt-4">
                            Examples of high-risk Processing encompass systematic and extensive
                            Processing activities, including profiling, large-scale Processing of
                            Sensitive Personal Data, and other activities with significant
                            consequences for Data Subjects.
                        </p>
                        <p className="mt-4">
                            The assessment must include a detailed description of the intended
                            Processing and objectives, an evaluation of necessity and proportionality,
                            proposed mitigation measures, and a dedicated team to conduct the
                            assessment when necessary.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Data Breach Management Procedure</h2>
                        <p>
                            Tennet personnel must promptly notify the IT Head of Unit upon detecting
                            an actual or suspected Data Breach. The IT Head of Unit shall expeditiously
                            address the potential breach, suspend access to the data, and report the
                            incident to the Board of Directors.
                        </p>
                        <p className="mt-4">
                            Tennet will implement measures including:
                        </p>
                        <ol className="list-decimal ml-6 space-y-3 text-base">
                            <li>
                                Identifying affected data records, incident timing, cause, affected
                                Data Subjects, and risk of serious harm.
                            </li>
                            <li>
                                Implementing or proposing measures to mitigate and address adverse
                                impacts.
                            </li>
                            <li>
                                Forming a Data Breach response team with IT, HR, general affairs,
                                business development, research personnel, and external experts as
                                necessary.
                            </li>
                            <li>
                                Informing Data Subjects promptly if the breach is likely to result in a
                                high risk to their rights and freedoms.
                            </li>
                        </ol>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Data Retention</h2>
                        <p>
                            We maintain your Personal Data as long as your account remains active or
                            for the duration necessary to furnish our Services, unless you initiate a
                            request for deletion. In certain instances, we may preserve Personal Data
                            for extended periods to meet legal obligations, settle disputes, recover
                            owed fees, or adhere to applicable laws, rules, or regulations.
                        </p>
                        <p className="mt-4">
                            Subsequently, we retain some information in a depersonalized or
                            aggregated manner, eliminating any personal identification.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Age Restriction</h2>
                        <p>
                            We do not knowingly collect or solicit Personal Data from anyone under
                            the age of 18. If you are under the age of 18, you are not allowed to use
                            the Services. Please refrain from accessing or using the Site or the App,
                            and do not attempt to send us any Personal Data.
                        </p>
                        <p className="mt-4">
                            If we confirm that we have inadvertently collected Personal Data from an
                            individual under 18, we will promptly delete that information.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">User Rights</h2>
                        <p>
                            Tennet acknowledges and respects your rights concerning your Personal
                            Data, as outlined by applicable laws and regulations.
                        </p>
                        <ol className="list-decimal ml-6 space-y-3 text-base">
                            <li>
                                <strong>Revocation of Consent:</strong> You have the right to revoke
                                your consent for Tennet to process, disclose, and/or store your
                                Personal Data. Upon revocation, Tennet will promptly delete/destroy
                                your Personal Data and cease further Processing.
                            </li>
                            <li>
                                <strong>Access Request:</strong> You can request and obtain a copy of
                                your Personal Data stored in your Tennet Account.
                            </li>
                            <li>
                                <strong>Change Request:</strong> You have the right to change, correct,
                                add, update, complete, and/or rectify any errors or inaccuracies in
                                your Personal Data within the Tennet system.
                            </li>
                            <li>
                                <strong>Removal Request:</strong> You can request Tennet to cease
                                processing, delete, and/or destroy your Personal Data from the Tennet
                                system. Deletion of Basic Data results in the closure of your Tennet
                                Account.
                            </li>
                        </ol>
                        <p className="mt-4">
                            Tennet may reject your requests if they are irrelevant to your stored
                            Personal Data or prohibited by competent authorities or Tennet’s internal
                            policies.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Limitation of Liability</h2>
                        <p>
                            You agree to release, hold harmless, indemnify, and defend Tennet,
                            including any officers, directors, employees, or agents of Tennet from
                            and against any and all requests, claims, losses, liabilities, costs,
                            damages, and expenses resulting directly or indirectly from:
                        </p>
                        <ol className="list-decimal ml-6 space-y-3 text-base">
                            <li>
                                Any loss due to Personal Data that is intercepted, accessed, stolen,
                                disclosed, altered, or destroyed by an unauthorized Third Party due to
                                factors beyond Tennet's control.
                            </li>
                            <li>
                                The security and confidentiality of Personal Data that have undergone
                                Processing, Disclosure, and/or storage by you or any party other than
                                Tennet.
                            </li>
                            <li>
                                All risks and consequences arising from your negligence and/or personal
                                errors in maintaining the security and confidentiality of your Personal
                                Data.
                            </li>
                            <li>
                                All consequences arising from the utilization of any media and/or
                                application that you employ to Disclose, Process, and/or store your
                                Personal Data.
                            </li>
                        </ol>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Governing Law And Dispute Resolution</h2>
                        <p>
                            These Terms of Use are governed and construed in accordance with the
                            laws of the Republic of Indonesia. Users and Tennet mutually agree that
                            any disputes arising from or related to this Privacy Policy will be
                            resolved by reference to the applicable laws and regulations, especially
                            those concerning personal data protection.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Language</h2>
                        <p>
                            In the event that this Privacy Policy is displayed in multiple
                            languages and there is a discrepancy between one language and another,
                            the Indonesian text will prevail.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Communication Methods</h2>
                        <p>
                            All notifications from Tennet to Users will be disseminated through our
                            Site, electronic mail (email), or short message service (SMS). Users can
                            submit any notifications related to this Privacy Policy or Personal Data
                            to Tennet through the designated email address: support@tennet.id.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-bold mb-3">Policy Changes</h2>
                        <p>
                            Tennet has the right to review and change this Privacy Policy from time
                            to time to ensure its alignment with the evolving nature of the Tennet
                            Service and any alterations in applicable laws and regulations. Users will
                            be informed about these changes through our site.
                        </p>
                        <p className="mt-4">
                            Users understand and agree that they are responsible for regularly
                            reviewing this Privacy Policy to stay informed about any updates or
                            modifications.
                        </p>
                    </section>
                </main>
            </div>
        </section>
    );
};

export default PrivacySection;
